import { FieldArray, useField, useFormikContext } from 'formik';

import Button from '../../../common/forms/Button';
import ButtonLoading from '../../../common/forms/ButtonLoading';
import WordSeparator from 'components/common/WordSeparator';

import { QuotasFormData } from './QuotasModal';
import { Quota } from './Quota';
import { Question } from 'types/domainModels';

export const QuotasForm = ({
  demographicQuestions,
  isSaving,
  onClickClose,
  onSubmit,
}: {
  demographicQuestions: Question[];
  isSaving: boolean;
  onClickClose(): void;
  onSubmit(): void;
}): JSX.Element => {
  const { submitForm } = useFormikContext();

  const [{ value: modalQuotas }] =
    useField<QuotasFormData['modalQuotas']>('modalQuotas');

  const currentlyUsedQuotaOptions = modalQuotas.flatMap((quota) =>
    quota.options.map((o) => o.value),
  );

  return (
    <div>
      <div className="w-edit-quotas-modal">
        <FieldArray
          name="modalQuotas"
          render={(arrayHelpers) => {
            return (
              <div>
                {modalQuotas.length === 0 && (
                  <p className="mb-4 text-sm">
                    No quotas are currently configured.
                  </p>
                )}
                {modalQuotas.map((_quota, index) => {
                  return (
                    <div key={index}>
                      <Quota
                        demographicQuestions={demographicQuestions}
                        index={index}
                        onClickRemove={() => {
                          arrayHelpers.remove(index);
                        }}
                        usedOptions={currentlyUsedQuotaOptions}
                      />
                      {index !== modalQuotas.length - 1 && (
                        <WordSeparator word="and" />
                      )}
                    </div>
                  );
                })}
              </div>
            );
          }}
        />
      </div>

      <div className="mt-8 flex gap-3 flex-row-reverse">
        <ButtonLoading
          hierarchy="primary"
          isLoading={isSaving}
          onClick={() => {
            submitForm();

            onSubmit();
          }}
          size="md"
          type="button"
        >
          Apply
        </ButtonLoading>
        <Button
          disabled={isSaving}
          hierarchy="secondary-gray"
          onClick={onClickClose}
          size="md"
          type="button"
        >
          Cancel
        </Button>
      </div>
    </div>
  );
};
